import React from 'react';

import AvailableErpAgentsPanel from './AvailableErpAgentsPanel';
import ServiceCallStatusMappingTable from './ServiceCallStatusMappingTable';

import classes from './ServiceCallStatusMappingPage.module.css';

const ServiceCallStatusMappingPage = () => {
    return (
        <div className={classes.ServiceCallStatusMappingPage}>
            <AvailableErpAgentsPanel />
            <ServiceCallStatusMappingTable />
        </div>
    );
};

export default ServiceCallStatusMappingPage;
